export const DEBUG_STORAGE_KEY = 'debug'

/**
 * Raw `localStorage` on purpose: `debug` is read synchronously at module load, before any
 * async persistent item could resolve. Storage may be blocked, so every access is guarded.
 */
export function readStoredDebug(): boolean | null {
    try {
        const stored = localStorage.getItem(DEBUG_STORAGE_KEY)
        return stored === null ? null : stored === 'true'
    } catch {
        return null
    }
}

export function writeStoredDebug(enabled: boolean): void {
    try {
        localStorage.setItem(DEBUG_STORAGE_KEY, String(enabled))
    } catch {
        // Storage blocked: the setting simply does not persist.
    }
}
